import {
	EXPERIMENT_CPE_NEW_MEXICO,
	EXPERIMENT_CPE_SOUTH_CAROLINA,
	handleExperiment
} from './ab-testing-service'

const SC_FUTURE_SCHOLAR_PLAN_ID = 68
const NM_THE_EDUCATION_PLAN_PLAN_ID = 36

const PLAN_ID_TO_EXPERIMENT_NAME_MAP = {
	[SC_FUTURE_SCHOLAR_PLAN_ID]: EXPERIMENT_CPE_SOUTH_CAROLINA,
	[NM_THE_EDUCATION_PLAN_PLAN_ID]: EXPERIMENT_CPE_NEW_MEXICO
}
const PLAN_ID_TO_URL_MAP = {
	[SC_FUTURE_SCHOLAR_PLAN_ID]: `/enroll-529-plan/future-scholar-529-college-savings-plan-direct-sold/start`,
	[NM_THE_EDUCATION_PLAN_PLAN_ID]: '/enroll-529-plan/new-mexico-the-education-plan/start'
}

/**
 * Get the variant for the CPE experiment
 * @param {number} planId - The plan ID
 * @param {object} cookie - The cookie instance to store the experiment variant
 * @param {object} store - The Vue store instance
 * @returns {Promise<string>} - A promise that resolves with the variant or 'redirect' if there's an error
 */
export async function getCpeExperimentVariant(planId, cookie, store) {
	try {
		const experimentName = PLAN_ID_TO_EXPERIMENT_NAME_MAP[planId]
		const variant = handleExperiment({ experimentName, cookie, store })
		return variant
	} catch (error) {
		console.error(`Error running AB Experiment: ${experimentName}`, error)
		return 'redirect'
	}
}

/**
 * Return the URL to the CPE page if the conditions are met
 * @param {string} cpeVariant - 'redirect' if control, 'cpe' if variant
 * @param {integer} planId - The plan ID
 * @returns {string | null} - The URL to the CPE page or null if the conditions are not met
 */
export function getUrlToCPEIfConditionsAreMet(cpeVariant, planId) {
	if (cpeVariant === 'cpe' && PLAN_ID_TO_URL_MAP[planId]) {
		return PLAN_ID_TO_URL_MAP[planId]
	}
	return null
}
